import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import ImperativeTable from "src/components/tables/ImperativeTable";
import PageStructure from "src/components/wrappers/PageStructure";
import ExampleTitle from "src/components/ExampleTitle";
import {
    imperativeDialog,
    imperativeExplanationData,
    imperativeExampleList,
    regularImperativeConjugations,
    irregularImperativeConjugations,
    commonIrregularImperatives
} from "src/data/individual-topics/Imperative";
import StoryCard from "src/components/cards/StoryCard";

const ImperativoContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`${isDarkMode ? "dark" : ""}`}>

            <div className="section">
                <ExplanationCard cardData={imperativeExplanationData} />
            </div>

            <ExampleTitle />

            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {imperativeExampleList.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <div className="section">
                <ExampleTitle title="Regular Imperative Conjugations" />
                {regularImperativeConjugations.map((verbData, index) => (
                    <ImperativeTable key={index} verbData={verbData} />
                ))}
            </div>

            <div className="section">
                <ExampleTitle title="Irregular Imperative Conjugations" />
                {irregularImperativeConjugations.map((verbData, index) => (
                    <ImperativeTable key={index} verbData={verbData} />
                ))}
            </div>
            <StoryCard
                story={imperativeDialog}
                title="Imperative Dialog: 👩‍🏫 Teacher and Student 🙋‍♂️"
            />

            <div className="section">
                <ExampleTitle title="Common Irregular Imperatives with Examples" />
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    {commonIrregularImperatives.map((example, index) => (
                        <ExampleCard key={index} example={example} />
                    ))}
                </div>
            </div>
        </div>
    );
};

const ImperativoScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Imperative"
            Page={<ImperativoContent />}
        />
    );
};

export default ImperativoScreen;
